import { Asset } from '../../assets';
import { Audit } from '../../auth';
import { IssueCreationSource, IssueType, Severity } from '../../graphql';
import { Location } from '../../location';
import { WorkspaceRoutine } from '../../routine';
import { Workspace } from '../../workspace';

export interface Issue extends Audit {
  id: string;
  severity: Severity;
  title: string;
  type: IssueType;
  asset: Asset;
  workspace: Workspace;
  routineVersion?: WorkspaceRoutine;
  location?: Location;
  createdFrom?: IssueCreationSource;
  createdFromAddress?: string;
  adjustCreationDate?: string;
  effectiveCreationDate?: string;
  isPinned?: boolean;
}
